<!-- Resultados del laboratorio -->
<div *ngIf="hayEnvioMuestrasInspectorEx" [formGroup]="form">
    <div class="row">

        <div class="col-md-12">
            <div class="card card-accent-success animated fadeIn">
                <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                    <div class="card-header-buscador">
                        <i class="fa fa-file-text-o"></i> Resultados Laboratorio
                        <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                        <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                    </div>
                </a>
                <div class="card-body-detalle">
                    <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label class="col-form-label required-field" for="inpIdResultadoEx">Resultado</label>
                                <ng-select loadingText="Cargando..."
                                           [items]="listResultadosEx"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdResultadoEx"
                                           [loading]="!(listResultadosEx)"
                                           notFoundText="Resultado no encontrado"
                                           [ngClass]="displayFieldCssNgSelect('IdResultadoEx')"
                                           placeholder="-- Seleccione un resultado --"
                                           clearAllText="Eliminar selección"
                                           appendTo="body">
                                </ng-select>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdResultadoEx','required')">
                                    El resultado es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="IdTecnicoDescripcion">Técnico</label>
                                <input formControlName="IdTecnicoDescripcion" name="IdTecnicoDescripcion" title="" class="form-control" id="IdTecnicoDescripcion" type="text" value="" [ngClass]="displayFieldCss('IdTecnicoDescripcion')" readonly>
                            </div>

                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="FechaResultado">Fecha</label>
                                <input formControlName="FechaResultado" name="FechaResultado" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('FechaResultado')" value="" readonly>
                            </div>

                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="ObservacionesResultado">Observaciones</label>
                                <textarea formControlName="ObservacionesResultado" name="ObservacionesResultado" title="" class="form-control" id="ObservacionesResultado" type="text" value=""></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
